import { ExampleSchema, MessageUnionType } from '@/types/schema';
import { getMessageAsStoredMessage, isMessageLike } from '@/utils/messages';

export const transformRuleGeneratedSchema = (
  example?: ExampleSchema
): ExampleSchema | undefined => {
  if (!example) return;

  const transformed = {
    ...example,
  };

  const safeExample: {
    inputs?: Record<string, unknown>;
    outputs?: Record<string, unknown>;
  } = example;

  if (
    Array.isArray(safeExample.inputs?.messages) &&
    safeExample.inputs?.messages.length &&
    safeExample.inputs?.messages.every(isMessageLike)
  ) {
    transformed.inputs = {
      input: safeExample.inputs?.messages.map(getMessageAsStoredMessage),
    };
  }

  if (
    Array.isArray(safeExample.outputs?.generations) &&
    safeExample.outputs.generations.length &&
    safeExample.outputs.generations.every(
      (item): item is { message: MessageUnionType } =>
        'message' in item && isMessageLike(item.message)
    )
  ) {
    transformed.outputs = {
      output: getMessageAsStoredMessage(
        safeExample.outputs.generations?.[0]?.message
      ),
    };
  }

  if (
    typeof safeExample.outputs?.output === 'object' &&
    safeExample.outputs?.output != null &&
    'message' in safeExample.outputs.output &&
    isMessageLike(safeExample.outputs?.output?.message)
  ) {
    transformed.outputs = {
      output: getMessageAsStoredMessage(safeExample.outputs.output.message),
    };
  }

  return transformed;
};
